import React from 'react'
import Icons from './Icons'
import NotFound from 'components/NotFound'

export default function ({ view }) {
  switch (view) {
    case 'icons':
      return <Icons />
    default:
      return <NotFound />
  }
}
